export default {
  heading: "登入资讯",
  accountSelect:{
    heading:"请选择您想要变更的登入资讯",
    cityId:"校本帐户",
    email:"会员帐户",
  }
};
